// extracted by mini-css-extract-plugin
export default {"image":"recentProjects_image__PTFan","slide":"recentProjects_slide__DGdLQ","loader":"recentProjects_loader__Lrwn9"};